module.exports = {

  append: false,

  loading: false,

  uri: window.location.pathname,

  init: function () {
    this.form = $('.js-activities-filter-form');
    this.loader = $('.js-loader');
    this.select = $('.js-activities-select', this.form);
    this.selectItems = $('.select-items__item');

    this.select.on('change', (this.onFilterChange.bind(this)));
    this.selectItems.on('click', (this.onFilterChange.bind(this)));
  },

  onFormSubmit: function (e) {
    e.preventDefault();
    this.loading = true;

    let serialized = this.form.serialize();
    serialized = serialized.replace(/[^&]+=\.?(?:&|$)/g, '');
    if (serialized) {
      serialized = '?' + serialized;
    }
    window.location.href = this.uri + serialized;

  },

  onFilterChange: function (e) {
    this.form.trigger('submit');
  },
};

